import { IsOptional, IsArray, IsString } from 'class-validator';

var EstopStatus;
(function (EstopStatus) {
  EstopStatus["Triggered"] = "Triggered";
  EstopStatus["Released"] = "Released";
  EstopStatus["Unkonwn"] = "Unknown";
})(EstopStatus || (EstopStatus = {}));

class MachineDeployment {}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

// model columns
class Machine {}
class GetMachinesRequest {
  constructor() {
    this.serial_numbers = [];
  }
}
__decorate([IsOptional(), IsArray(), IsString({
  each: true
}), __metadata("design:type", Array)], GetMachinesRequest.prototype, "serial_numbers", void 0);
// states from machine cloud api
class MachineStates {}
class MachineForwardHttpRequest {}
class MachinePerformHttpRequest {}
class HttpRequest {}

class AddParticipantToMeetingRequest {}
class AddParticipantToMeetingResponse {}
class CreateMeetingAndAddParticipantToMeetingRequest {}
class CreateMeetingAndAddParticipantToMeetingResponse {}
class CreateMeetingRequest {}
class CreateMeetingResponse {}

class GetBusinessHoursResponse {}
class GetRailsTokenResponse {}
class UpdateZendeskTicketResponse {}

/**
 * Currently this enum contains both MQTT and WebSocket events, but they should be separated.
 * We should also adopt the same naming convention everywhere.
 */
var WebSocketMessageEvent;
(function (WebSocketMessageEvent) {
  WebSocketMessageEvent["keepConnectionAlive"] = "KEEP_CONNECTION_ALIVE";
  WebSocketMessageEvent["performHttpRequest"] = "PERFORM_HTTP_REQUEST";
  WebSocketMessageEvent["register"] = "REGISTER";
  WebSocketMessageEvent["updateMachineMotionClient"] = "UPDATE_MACHINE_MOTION_CLIENT";
  WebSocketMessageEvent["machineMotionClientUpdateState"] = "UPDATE_MACHINE_MOTION_CLIENT_STATE";
  WebSocketMessageEvent["sendMachineMotionClientVersion"] = "SEND_MACHINE_MOTION_CLIENT_VERSION";
  WebSocketMessageEvent["estop"] = "execution-engine/estop";
  WebSocketMessageEvent["error"] = "error";
  WebSocketMessageEvent["remoteAccessStatus"] = "machine-cloud/remote-access";
  WebSocketMessageEvent["remoteControlFailed"] = "machine-cloud/remote-access-failed";
  WebSocketMessageEvent["executionEngineApplicationState"] = "execution-engine/application/state";
  WebSocketMessageEvent["authenticateBrowserClient"] = "AUTHENTICATE_BROWSER_CLIENT";
  WebSocketMessageEvent["connectivity"] = "machine-cloud/connectivity";
})(WebSocketMessageEvent || (WebSocketMessageEvent = {}));

export { AddParticipantToMeetingRequest, AddParticipantToMeetingResponse, CreateMeetingAndAddParticipantToMeetingRequest, CreateMeetingAndAddParticipantToMeetingResponse, CreateMeetingRequest, CreateMeetingResponse, EstopStatus, GetBusinessHoursResponse, GetMachinesRequest, GetRailsTokenResponse, HttpRequest, Machine, MachineDeployment, MachineForwardHttpRequest, MachinePerformHttpRequest, MachineStates, UpdateZendeskTicketResponse, WebSocketMessageEvent };
